var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("Top Products")]),_c('card-actions')],1),_c('div',{staticClass:"body"},[_c('chart',{staticClass:"chartist",attrs:{"options":_vm.options,"id":"chart-top-products","autoresize":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }